module.exports = __webpack_public_path__ + "static/media/Reset Password.b2e148a4.svg";